const items = [
  "Landing pages",
  "Sitios web",
  "Tiendas B2B",
  "Apps web a la medida",
  "Conversión",
  "React",
  "FastAPI",
  "IA como acelerador",
  "Velocidad de ejecución",
];

export const Marquee = () => (
  <section data-testid="marquee" className="py-10 border-y border-white/10 bg-[var(--surface)] overflow-hidden">
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0" aria-hidden={dup === 1}>
          {items.map((it, i) => (
            <span key={`${dup}-${i}`} className="flex items-center">
              <span className="font-display text-2xl sm:text-3xl font-semibold text-zinc-500 px-8">
                {it}
              </span>
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--magenta)]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
